// TODO: move into routes folder
export enum ConneqtSubRoutes {
  received = 'received',
  sent = 'sent',
  all = 'all',
}
